import React from "react";
import { Logo } from "./Logo";
import ThemeToggle from "./ThemeToggle";
import { Tv, Star, Clock, ListVideo } from "lucide-react";

const FEATURES = [
  { icon: Tv, label: "Live TV from your own playlists" },
  { icon: Star, label: "Save your favorite channels" },
  { icon: Clock, label: "Recently watched, one click away" },
  { icon: ListVideo, label: "M3U / M3U8 (URL or file)" },
];

export default function AuthLayout({ children, subtitle }) {
  return (
    <div className="min-h-screen w-full flex bg-tv-darkest">
      {/* Left brand panel */}
      <div className="hidden lg:flex w-[46%] relative overflow-hidden border-r border-tv-border">
        <div
          className="absolute inset-0 opacity-[0.18]"
          style={{
            background:
              "radial-gradient(circle at 25% 20%, #2DD4BF 0%, transparent 45%), radial-gradient(circle at 80% 75%, #38BDF8 0%, transparent 45%)",
          }}
        />
        <div className="relative z-10 flex flex-col justify-between p-14 w-full">
          <Logo size={26} />
          <div>
            <h1 className="text-5xl font-extrabold leading-tight tracking-tight">
              Your channels.
              <br />
              <span className="tv-gradient-text">Beautifully live.</span>
            </h1>
            <p className="mt-5 text-tv-sub max-w-md text-[15px] leading-relaxed">
              TVVerse is a personal IPTV player. Bring your own M3U playlist and watch
              live TV anywhere. Now on the web, invitation only.
            </p>
            <div className="mt-10 space-y-3.5">
              {FEATURES.map((f, i) => (
                <div
                  key={f.label}
                  className="flex items-center gap-3.5 animate-fadeIn"
                  style={{ animationDelay: `${i * 80}ms` }}
                >
                  <div className="w-9 h-9 rounded-lg bg-tv-card border border-tv-border flex items-center justify-center text-tv-cyan">
                    <f.icon size={17} />
                  </div>
                  <span className="text-tv-sub text-sm">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
          <p className="text-tv-muted text-xs">© 2026 MediaVerse Labs · TVVerse v1.5</p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-10 relative">
        <div className="absolute top-5 right-5">
          <ThemeToggle />
        </div>
        <div className="w-full max-w-[420px] animate-fadeIn">
          <div className="lg:hidden mb-8 flex justify-center">
            <Logo size={24} />
          </div>
          {subtitle}
          {children}
        </div>
      </div>
    </div>
  );
}
